import { Target } from '../types/chartData';

export function getTargetsMinMax(targets: Target[]) {
  if (targets.length === 0) {
    return { max: 0, min: 0 };
  }

  const startingValue = targets[0].value;

  return targets.reduce(
    (acc, cur) => {
      if (cur.value > acc.max) {
        acc.max = cur.value;
      } else if (cur.value < acc.min) {
        acc.min = cur.value;
      }
      return acc;
    },
    { max: startingValue, min: startingValue }
  );
}
